import { SelectOptionType } from "../../../types/types";

export type WorksFilters = {
  customerIds: SelectOptionType[];
  workName: SelectOptionType[];
  userIds: SelectOptionType[];
  workStatuses: SelectOptionType[];
  worktypeIds: SelectOptionType[];
  startDates: [] | ["BetweenDates"];
  dueDates: [] | ["BetweenDates"];
  fromDate: Date | null;
  toDate: Date | null;
};

export const EMPTY_WORKS_FILTERS: WorksFilters = {
  customerIds: [],
  workName: [],
  userIds: [],
  workStatuses: [],
  worktypeIds: [],
  startDates: [],
  dueDates: [],
  fromDate: null,
  toDate: null,
};
